module.exports = __webpack_public_path__ + "img/logo-new-zl.e9b41b4b.svg";